<main class="clone-dialog p-3 ri-w-600">
    <div class="ri-dialog-content">
        <div class="source-info mb-3">
            <span class="source-label">Cloning from:</span>
            <span class="source-name">{{ data.sourceTemplate.templateName }}</span>
        </div>

        <form [formGroup]="cloneForm">
            <mat-form-field appearance="fill" class="w-100 mb-1">
                <mat-label>New Template Name</mat-label>
                <input
                    matInput
                    type="text"
                    autocomplete="off"
                    autocorrect="off"
                    autocapitalize="none"
                    spellcheck="false"
                    formControlName="templateName"
                    name="cloneTemplateName"
                    placeholder="Enter new template name (no spaces)"
                    noSpaces
                />
                <mat-error *ngIf="cloneForm.get('templateName')?.hasError('required')">
                    Template name is required
                </mat-error>
                <mat-error *ngIf="cloneForm.get('templateName')?.hasError('maxlength')">
                    Template name must be 50 characters or less
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" class="w-100 mb-1">
                <mat-label>Description</mat-label>
                <textarea
                    matInput
                    formControlName="description"
                    name="cloneDescription"
                    rows="3"
                    placeholder="Enter template description (optional)">
                </textarea>
            </mat-form-field>
        </form>

        <div class="clone-hint">
            <mat-icon>info_outline</mat-icon>
            <span>The cloned template will copy all content but will not include publishing history.</span>
        </div>
    </div>

    <div class="ri-dialog-footer">
        <div class="d-flex justify-content-end mt-4 gap-2">
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="cancel()">
                Cancel
            </button>
            <button
                type="submit"
                class="btn btn-sm btn-primary"
                (click)="clone()"
                [disabled]="!hasChanges()">
                Clone Template
            </button>
        </div>
    </div>
</main>
